import * as React from 'react';
import { OwnerCompanyForm } from '../../components/OwnerCompanyForm';
import { EditItem } from '../../components/OwnerList/EditItem';
import { SingleCompanyOwnerSummary } from '../../components/SingleCompanyOwnerSummary';
import { BoxHeading } from '../../components/box';
import type { CompanyOwner } from '../../state/editor';

type Mode = 'view' | 'edit';

interface State {
  mode: Mode;
}
interface Props {
  owner: CompanyOwner | undefined;
}

export class SingleCompanyOwnerSection extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    if (props.owner) {
      this.state = { mode: 'view' };
    } else {
      this.state = { mode: 'edit' };
    }
  }

  modeSetter = (mode: Mode) => {
    return () => {
      this.setState({ mode });
    };
  };

  render() {
    const { mode } = this.state;
    const { owner } = this.props;
    return mode === 'edit' || !owner ? (
      <EditItem>
        <BoxHeading>Eierselskapet</BoxHeading>
        <OwnerCompanyForm
          initialOrgId={owner?.item?.orgId}
          onDone={this.modeSetter('view')}
          hideCancelButton={owner === undefined}
        />
      </EditItem>
    ) : (
      <SingleCompanyOwnerSummary
        owner={owner}
        onClick={this.modeSetter('edit')}
      />
    );
  }
}
